module.exports = __webpack_public_path__ + "img/111.7ccf9f50.svg";